import React, { useState } from "react";
import RecentTask from "./RecentTask";
import CompletedTasks from "../CompletedTasks";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { svgIcons } from "../../../../style/fonts/SvgIcons";
import TasksSidebar from "../../ProjectTabs/ProjectTasks/TasksSidebar";
import AssignConfirmationModal from "./AssignConfirmationModal";

const LeadUserTask = () => {
  const [selectedId, setselectedId] = useState<any[]>([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const disable = selectedId?.length > 1 || selectedId?.length === 0 || selectedId?.length === null || selectedId?.length === undefined;

  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleAddTasks = () => {
    setActivityTogglePopup(true);
    setIsEditing(false);
  };
  const handleEditTasks = () => {
    setActivityTogglePopup(true);
    setIsEditing(true)
  };

  const closeSidebar = () => {
    setActivityTogglePopup(false);
  };
  const handleClose = () => {
    setShowConfirmationModal(false);

};
const handleShowConfirmModal=()=>{
  setShowConfirmationModal(true);
}
  return (
    <>
      <AssignConfirmationModal show={showConfirmationModal} handleClose={handleClose} />
      <TasksSidebar activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar} isEditing={isEditing} />
      <div className="row">
        <div className="col-md-12">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Col sm={12}>
                <div className="card card-css">
                  <div className="card-body p-2">
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="col-md-6">
                          <div className="d-flex">
                            <Nav variant="pills" className="flex">
                              <Nav.Item>
                                <Nav.Link eventKey="first">General </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="second">Assigned</Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex gap-3 align-items-center justify-content-end">
                            <button className="mb-0 btn btn-trasnparent border-0" disabled={disable} onClick={() => handleEditTasks()}><span className="me-1">{svgIcons.updateIcon}</span>Edit</button>
                            <button className="btn btn-primary" onClick={() => handleAddTasks()}>
                              + New Task
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={12}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <RecentTask setselectedId={setselectedId}  handleShowConfirmModal={handleShowConfirmModal} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <CompletedTasks setselectedId={setselectedId} />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>

        </div>
      </div>
    </>
  );
};

export default LeadUserTask;
